import React from 'react';
import styled from 'styled-components';
import ICellProps from '../ICellProps';
import Point from './components/Point';
import TripStopCoords from './components/TripStopCoords';

interface IProps extends ICellProps {
  row?: any;
  field?: any;
  config?: any;
  onValueChange?: (field: any, value: any) => void;
}

const getField = (props: IProps): React.ReactNode => {
  const { row, field } = props;
  switch (field.composite.type) {
    case 'point_coords':
      return (
        <Point
          row={row}
          composite={field.composite}
          config={props.config}
          onValueChange={props.onValueChange}
          value={props.value}
          readonly={props.readonly}
          isCoordsArray={field.composite.isCoordsArray}
        />
      );
    case 'stopscoords':
      return (
        <TripStopCoords
          value={props.value}
          row={row}
          composite={field.composite}
          config={props.config}
          readonly={props.readonly}
        />
      );
  }
  return null;
};

const DataBlock = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-weight: bold;
  align-items: center;
`;

const Composite: React.FC<IProps> = (props: IProps) => {
  return <DataBlock>{getField(props)}</DataBlock>;
};

export default Composite;
